import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Library, MessageSquare, Briefcase, Share2, Zap } from 'lucide-react';

function BottomNav() {
  const navigate = useNavigate();
  const location = useLocation();

  const navItems = [
    { path: '/library', icon: Library, label: 'Library' },
    { path: '/zap-tools', icon: Zap, label: 'Zap Tools' },
    { path: '/ask-ai', icon: MessageSquare, label: 'Ask AI' },
    { path: '/workspace', icon: Briefcase, label: 'Workspace' },
    { path: '/share', icon: Share2, label: 'Share' },
  ];

  const isActive = (path) => location.pathname.startsWith(path);

  return (
    <nav className="fixed bottom-0 left-0 right-0 bg-white border-t border-gray-200 shadow-lg z-50">
      <div className="max-w-screen-xl mx-auto">
        <div className="flex justify-around items-center h-16">
          {navItems.map((item) => {
            const Icon = item.icon;
            const active = isActive(item.path);
            return (
              <button
                key={item.path}
                onClick={() => navigate(item.path)}
                className={`flex flex-col items-center justify-center flex-1 h-full transition-colors ${
                  active
                    ? 'text-emerald-600'
                    : 'text-gray-500 hover:text-emerald-500'
                }`}
              >
                <Icon size={24} className="mb-1" />
                <span className="text-xs font-medium">{item.label}</span>
              </button>
            );
          })}
        </div>
      </div>
    </nav>
  );
}

export default BottomNav;